import cx from "clsx";
import React from "react";
import { isSpecificSite } from "../../utils/isSpecificSite";
import { HeartLarge } from "../common/Icons";
import * as styles from "./MyFavouritesIcon.module.scss";

export interface MyFavouritesIconProps {
	className: string;
	count: number;
}

export const MyFavouritesIcon: React.FC<MyFavouritesIconProps> = ({
	className,
	count,
}) => {
	isSpecificSite("ie", "MyFavouritesIcon");
	return (
		<a
			className={className}
			href={"/rehoming/dogs/favourites"}
			aria-label="Visit your favourites"
		>
			<HeartLarge width="32" height="32" />
			<span
				className={cx(styles.favnotification, styles.favnotificationie)}
				aria-hidden="true"
			>
				{count}
			</span>
		</a>
	);
};

export default MyFavouritesIcon;
